import { render, staticRenderFns } from "./wa-tabs.vue?vue&type=template&id=f0ebb8fc&scoped=true&"
import script from "./wa-tabs.vue?vue&type=script&lang=js&"
export * from "./wa-tabs.vue?vue&type=script&lang=js&"
import style0 from "./wa-tabs.vue?vue&type=style&index=0&id=f0ebb8fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ebb8fc",
  null
  
)

export default component.exports